module.exports = __webpack_public_path__ + "img/202411290202.1cfe5bf7.png";